export default "__VITE_ASSET__CpV9jik1__"